module.exports = __webpack_public_path__ + "static/media/account.cee358e9.svg";